import { defineRule } from '../define-rule'
import { assertNotNullish, assertPrimitives } from '@/libs/utils/assertion.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type CharMaxRuleConstructorParams = BaseRuleConstructorParams<{ max: number }>

export const charMax = defineRule(
  'char_max',
  ({ config, errorMessage }: CharMaxRuleConstructorParams) => {
    const { max } = config
    const error = errorMessage ?? false
    assertNotNullish(max)
    return (value) => {
      try {
        assertPrimitives(value, 'string', 'number')
        return String(value).length <= max || error
      } catch (e) {
        console.error('Error while executing dateIsValid', e)
        return error
      }
    }
  }
)
